export default __webpack_public_path__ + "static/media/guidee-to-allowable-status-changes.b35e247f.svg";